// import MaskedInput from 'react-text-mask'
// import { makeTelMask, isDateValid } from './common'
// import { history } from './history'
import { useState } from 'react'
import { UFs, getCitiesByState } from './common'
import CheckboxListItem from "./CheckboxListItem"
import MandatoryField from './MandatoryField'


const canSubmit = (data) => {
  // console.log('Checking can submit', data)
  let result = 
    !!data.uf && data.uf.trim() !== '' && data.uf !== '-' &&
    !!data.cidade && data.cidade.trim() !== '' && data.cidade !== '-'
  if (data.uf === 'SP' && data.cidade === 'São Paulo') {
    result = result && !!data.regiao && data.regiao.trim() !== ''
  }
  // const d = data.disponibilidade
  // let disp = d['fds'] || d['manhã'] || d['tarde'] || d['noite'] || d['total']
  // result = result && disp

  let values = Object.values(data.disponibilidade)
  let disp = false
  for (let i = 0; i < values.length; i++) {
    if (values[i] === true) {
      disp = true
      break
    }
  }
  result = result && disp

  return result
}


const FormPage2 = (props) => {
  const [valid, setValid] = useState(false)
  const data = props.formData
  setTimeout(() => setValid(canSubmit(data), 1))
// console.log('Form page 2 here', props)
  return (

<>
<form className="form"
  style={{
  alignItems: 'center'
}}>

<div className="form-header">Disponibilidade</div>

<div className="form-field-group">
  <MandatoryField title='Estado onde mora:' />
  <select name="uf" className="form-text"
    value={data.uf ? data.uf : ''}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   uf: e.target.value
      // }
      // this.setState({formData})
      // getCitiesByState(e.target.value)
      props.setForm({uf: e.target.value, cidade: ''})
      setValid(canSubmit({...data, uf: e.target.value}))
    })}
  >
    {UFs.map((uf) => (
      <option key={uf.sigla} value={uf.sigla}>{uf.nome}</option>
    ))}
  </select>
</div>

<div className="form-field-group">
  <MandatoryField title='Cidade:' />
  <select name="cidade-list" className="form-text"
    value={data.cidade ? data.cidade : ''}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   cidade: e.target.value
      // }
      // this.setState({formData})
      props.setForm({cidade: e.target.value})
      setValid(canSubmit({...data, cidade: e.target.value}))
    })}
  >
    <option key={'cityBlank'} value={'-'}></option>
    {getCitiesByState(data.uf).map((c) => (
      // null
      !!c && c !== '' && <option key={c} value={c}>{c}</option>
    ))}
  </select>
{/* </div> */}


{data.uf === 'SP' && data.cidade === 'São Paulo'
&&
(
  <div className="form-sub-field">
  <MandatoryField title='Região de residência (Zona sul, zona norte etc):' />
  <input type="text" name="regiao" className="form-text"
    value={data.regiao ? data.regiao : ''}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   regiao: e.target.value
      // }
      // this.setState({formData})
      props.setForm({regiao: e.target.value})
      setValid(canSubmit({...data, regiao: e.target.value}))
    })}
  />
</div>
)}
</div>

<div className="form-field-group">
  Possui carro?
  <select name="carro" className="form-text"
    value={data.carro ? data.carro : 'não'}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   carro: e.target.value
      // }
      props.setForm({carro: e.target.value})
    })}>
    <option value="-"></option>
    <option value="não">Não</option>
    <option value="sim">Sim</option>
  </select>
</div>

<div className="form-field-group">
  Possui moto?
  <select name="moto" className="form-text"
    value={data.moto ? data.moto : 'não'}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   moto: e.target.value
      // }
      props.setForm({moto: e.target.value})
    })}>
    <option value="-"></option>
    <option value="não">Não</option>
    <option value="sim">Sim</option>
  </select>
</div>

<div className="form-field-group">
  <MandatoryField title='Disponibilidade de horário:' />
  <div className="form-list-box" style={{height: '108px'}}
>
    <CheckboxListItem 
      title="Manhã"
      checked={!!data.disponibilidade && data.disponibilidade['manhã']}
      onPress={() => {
        let disponibilidade = {...data.disponibilidade}
        disponibilidade['manhã'] = !disponibilidade['manhã']
        // let formData = {
        //   ...data,
        //   disponibilidade
        // }
        props.setForm({disponibilidade})
        setValid(canSubmit({...data, disponibilidade}))

      }}
      noBorder={false}
    />
    <CheckboxListItem 
      title="Tarde"
      checked={!!data.disponibilidade && data.disponibilidade['tarde']}
      onPress={() => {
        let disponibilidade = {...data.disponibilidade}
        disponibilidade['tarde'] = !disponibilidade['tarde']
        // let formData = {
        //   ...data,
        //   disponibilidade
        // }
        props.setForm({disponibilidade})
        setValid(canSubmit({...data, disponibilidade}))
      }}
      noBorder={false}
    />
    <CheckboxListItem 
      title="Noite"
      checked={!!data.disponibilidade && data.disponibilidade['noite']}
      onPress={() => {
        let disponibilidade = {...data.disponibilidade}
        disponibilidade['noite'] = !disponibilidade['noite']
        // let formData = {
        //   ...data,
        //   disponibilidade
        // }
        props.setForm({disponibilidade})
        setValid(canSubmit({...data, disponibilidade}))
      }}
      noBorder={false}
    />
    <CheckboxListItem 
      title="Fim de semana"
      checked={!!data.disponibilidade && data.disponibilidade['fds']}
      onPress={() => {
        let disponibilidade = {...data.disponibilidade}
        disponibilidade['fds'] = !disponibilidade['fds']
        // let formData = {
        //   ...data,
        //   disponibilidade
        // }
        props.setForm({disponibilidade})
        setValid(canSubmit({...data, disponibilidade}))
      }}
      noBorder={false}
    />
    <CheckboxListItem 
      title="Total"
      checked={!!data.disponibilidade && data.disponibilidade['total']}
      onPress={() => {
        let disponibilidade = {...data.disponibilidade}
        disponibilidade['total'] = !disponibilidade['total']
        // let formData = {
        //   ...data,
        //   disponibilidade
        // }
        props.setForm({disponibilidade})
        setValid(canSubmit({...data, disponibilidade}))
      }}
      noBorder={false}
    />
  </div>
  <div className="form-sub-field">
    Obs:
    <input type="text" name="disponibilidadeObs" className="form-text"
    // style={{marginLeft: '8px'}}
    value={data.disponibilidadeObs ? data.disponibilidadeObs : ''}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   disponibilidadeObs: e.target.value
      // }
      // this.setState({formData})
      props.setForm({disponibilidadeObs: e.target.value})
    })}
  />
  </div>

</div>


<div className="form-send-row">
<button
  // onClick={() => history.goBack()}
  // disabled={!this.state.cpf || !this.state.isCPFValid || this.state.loading}
  className="login-button"
  onClick={() => props.onPrev()}
>{`${'< Voltar'}`}
</button>
<button
  // disabled={!this.state.cpf || !this.state.isCPFValid || this.state.loading}
  disabled={!valid}
  className="login-button"
  onClick={() => props.onNext()}
>{`${'Continuar >'}`}</button>
</div>
{/* {
!!this.state.error &&
<div className="login-error">{this.state.error}</div>
} */}
</form>
</>
)
}

export default FormPage2
